export const baseUrl = process.env.REACT_APP_BASE_URL;

export const apiConfig = {
  login: baseUrl + "admin/login",
  otpVerify: baseUrl + "admin/loginOTPVerify",
  getUsers: baseUrl + "admin/listUser",
  resentOtp: baseUrl + "admin/forgotPasswordSendOTP",
  assetTransaction: baseUrl + "admin/assetsTransactionList",
  blockWithdraw: baseUrl + "admin/block-unblock-withdraw",
  depositManyInternalWallet: baseUrl + "admin/deposite-many-internalwallet",
  distributeIncome: baseUrl + "admin/distribute-income",
  getPlanDetails: baseUrl + "buy/getTradingBotDetails",
  getPlanForUsers: baseUrl + "buy/get-plan-for-users",
  getAssetWithdrawlist: baseUrl + "admin/asste-transaction-withdraw-list",
  approveWithdrawReq: baseUrl + "admin/approveWithdrawReq",
  rankDistributions: baseUrl + "admin/rank-achivers",
  rankRewardDistributions: baseUrl + "admin/distribute-rank-reward",
  getFeeReward: baseUrl + "admin/get-fee-reward",
  updateFeeReward: baseUrl + "admin/add-update-fee-reward",
  getMaintainenceStatus: baseUrl + "admin/get-settings",
  updateMaintainence: baseUrl + "admin/add-update-setting",
  subscription: baseUrl + "admin/viewUserSubscriptionDetails",
  rewardHistory: baseUrl + "admin/get-reward-history",
  depositReport: baseUrl + "admin/get-deposit-report",
  getMatchingRequest: baseUrl + "admin/get-match-reward-request",
  claimMatchingRequest: baseUrl + "admin/update-match-reward-request",
  addBanner:  baseUrl + "banner/addbannerOfWeb",
  editBanner: baseUrl + "banner/editBannerofWeb",
  deleteBanner: baseUrl + "banner/deleteBannerofWeb",
  fetchBanner: baseUrl + "banner/get-all-banners-of-web",
  dashboardCount: baseUrl + "admin/adminDashbordcount",
  planData: baseUrl + "admin/get-ivt-plan",
  completePlanData: baseUrl + "admin/update-ivt-plan"
};
// test 1
